module.exports = __webpack_public_path__ + "media/pandeaming.263b180a.mp4";